
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Firmenkategorie',
    minies: false,
    media: false,
    vuexnamespace: 'companycategories',
    initmutation:'companycategories/COMPANYCATEGORY_INIT_COMPANYCATEGORY',
    backlink:'companies',
    duplicateable:true,
    helptext:""
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};